import React, { Component } from 'react';
import { Row, Col, Select } from 'antd';

class StatusReport extends Component {
    constructor(props) {
        super(props);

        this.onChangeSelect = this.onChangeSelect.bind(this);

        this.state = {
            status: "",
        }
    }

    componentDidMount() {

    }

    onChangeSelect(value, e) {
        this.setState({ [e.props.name]: value });
        this.props.onchange(value)
    }

    render() {
        const Option = Select.Option
        return (
            <Select
                defaultValue={0}
                name="status"
                onChange={this.onChangeSelect}
                value={this.state.status}
            >
                <Option name="status" value="">Status</Option>
                <Option name="status" value="0">Pending</Option>
                <Option name="status" value="1">In Progress</Option>
                <Option name="status" value="2">Complete</Option>
                <Option name="status" value="99">Error</Option>
            </Select>
        );
    }
}

export default StatusReport;



// WEBPACK FOOTER //
// ./src/views/Dropdown/StatusReport.js